const DATABASE = 'amposter-quran-library';
let opening;
function open() {
  if (!opening) opening = new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => request.result.createObjectStore('texts', {keyPath:'key'});
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => { opening = null; reject(request.error); };
  });
  return opening;
}
export async function readQuranRecords() {
  const db = await open();
  return new Promise((resolve,reject) => {
    const request = db.transaction('texts').objectStore('texts').getAll();
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
export async function writeQuranRecords(records) {
  const db = await open();
  return new Promise((resolve,reject) => {
    const transaction = db.transaction('texts','readwrite');
    records.forEach(record => transaction.objectStore('texts').put(record));
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
    transaction.onabort = () => reject(transaction.error || new Error('storage-aborted'));
  });
}
export async function removeQuranRecord(key) {
  const db = await open();
  return new Promise((resolve,reject) => {
    const transaction = db.transaction('texts','readwrite');
    transaction.objectStore('texts').delete(key);
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
    transaction.onabort = () => reject(transaction.error || new Error('storage-aborted'));
  });
}
